import { IReducedError } from './application/http-new.interfaces';

export namespace Utils {
    export function experienceText(exp: string | undefined): string {
        if (!exp || exp === '') return '';

        const years = parseInt(exp.split(' ')[0]);
        if (isNaN(years)) {
            if (exp.toLowerCase().includes('стаж')) return exp;
            return `Стаж: ${exp}`;
        }
        const lastDigit = years % 10;
        const lastTwoDigits = years % 100;

        if (lastTwoDigits >= 11 && lastTwoDigits <= 19) {
            return `Стаж ${years} лет`;
        }

        switch (lastDigit) {
            case 1:
                return `Стаж ${years} год`;
            case 2:
            case 3:
            case 4:
                return `Стаж ${years} года`;
            default:
                return `Стаж ${years} лет`;
        }
    }
    export function getErrorMessage(
        error: unknown,
        fallback = 'Что-то пошло не так, попробуйте позже.',
    ): string {
        const directError = toRecord(error);
        const response = toRecord(directError?.['response']);
        const responseData = toRecord(response?.['data']);
        const angularError = toRecord(directError?.['error']);

        const message =
            getString(responseData, 'message') ||
            getString(responseData, 'msg') ||
            getString(angularError, 'message') ||
            getString(angularError, 'msg') ||
            getString(directError, 'message') ||
            getString(directError, 'msg');

        return message || fallback;
    }
    export function getErrorCode(error: unknown): number {
        const directError = toRecord(error);
        const response = toRecord(directError?.['response']);
        const responseData = toRecord(response?.['data']);
        console.log('response', response);

        const code =
            getNumber(responseData, 'statusCode') ||
            getNumber(response, 'status');

        return code;
    }

    export function errorTypeGuard(err: unknown): IReducedError {
        const directError = toRecord(err);
        const response = toRecord(directError?.['response']);
        const responseData = toRecord(response?.['data']);
        const statusCode =
            getNumber(responseData, 'statusCode') ||
            getNumber(directError, 'statusCode') ||
            getNumber(response, 'status') ||
            getNumber(directError, 'status') ||
            0;

        return {
            success: false,
            statusCode,
            message: getErrorMessage(err, ''),
        };
    }
}

function toRecord(value: unknown): Record<string, unknown> | null {
    return typeof value === 'object' && value !== null
        ? (value as Record<string, unknown>)
        : null;
}

function getString(
    record: Record<string, unknown> | null,
    key: string,
): string {
    const value = record?.[key];
    return typeof value === 'string' ? value : '';
}

function getNumber(
    record: Record<string, unknown> | null,
    key: string,
): number {
    const value = record?.[key];
    return typeof value === 'number' ? value : 0;
}
